import ListDetail from './ListDetail';

export default ListDetail;